import { Component, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import {
  IconSizeEnum, ImageRatioEnum, IRating, SdBannerComponent, SdIconComponent, SdLinkComponent, SdSkeletonComponent,
  SdTagComponent, SdThemeComponent, SdTitleComponent, SkeletonAppearanceEnum
} from '@seb/web-design-system/core';

import { SdRecipeUserComponent } from '@seb/web-design-system/recipe-user';
import { SdRatingComponent } from '@seb/web-design-system/reviews';

import type { IRecipeCard } from './recipe-card.interface';

@Component({
  selector: 'sd-recipe-card',
  templateUrl: './recipe-card.component.html',
  styleUrls: ['./recipe-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdRecipeUserComponent,
    SdIconComponent,
    SdTitleComponent,
    SdRatingComponent,
    SdSkeletonComponent,
    SdBannerComponent,
    SdTagComponent,
    SdLinkComponent
  ]
})
export class SdRecipeCardComponent extends SdThemeComponent {
  @Input()
  isLoading = false;

  @Input()
  recipeContent: IRecipeCard;

  @Input()
  titleLevel = 4;

  @Input()
  maxStar = 5;

  @Input()
  twicPicsAutoSize = true;

  @Output()
  recipeClicked = new EventEmitter();

  get ratingData(): IRating {
    return {
      averageRatings: Math.ceil(this.recipeContent.rating * 10) / 10,
      numberOfReviews: this.recipeContent.countReviews || 0
    };
  }

  iconSize = IconSizeEnum;
  imageRatio = ImageRatioEnum;
  skeletonAppearanceEnum = SkeletonAppearanceEnum;

  onRecipeClick() {
    this.recipeClicked.emit();
  }
}
